import axios from 'axios';

import { correlationIdInterceptor } from '@altirllc/shared/utils/api/common/interceptors';
import { identity } from '@altirllc/shared/utils/functionalUtils';

import { handleErrorInterceptor } from '../common';
import { identityServer, publicProfileServer } from '../urls';

const apiConfig = {
  publicProfileService: {
    baseURL: publicProfileServer,
    headers: {},
    request: [correlationIdInterceptor],
    response: [handleErrorInterceptor],
  },

  identityService: {
    baseURL: identityServer,
    headers: {},
    request: [],
    response: [handleErrorInterceptor],
  },
};

const createPublicService = (service: keyof typeof apiConfig) => {
  const { baseURL, headers, request, response } = apiConfig[service];
  const instance = axios.create({ baseURL, headers });

  instance.interceptors.request.use(...request);
  response.forEach((interceptor) => instance.interceptors.response.use(identity, interceptor));
  return instance;
};
export const publicProfileService = createPublicService('publicProfileService');
export const identityService = createPublicService('identityService');
